<template>
    <label class="boolean-switch" :class="{ 'boolean-switch-disabled': disabled }">
        <input
            class="boolean-switch-input"
            type="checkbox"
            :checked="modelValue"
            :disabled="disabled"
            @change="emit('update:modelValue', ($event.target as HTMLInputElement).checked)"
        >
        <span class="boolean-switch-control" aria-hidden="true">
            <span class="boolean-switch-thumb"></span>
        </span>
        <span class="boolean-switch-label"><slot /></span>
    </label>
</template>

<script setup lang="ts">
defineProps<{
    modelValue: boolean
    disabled?: boolean
}>()

const emit = defineEmits<{
    (event: 'update:modelValue', value: boolean): void
}>()
</script>

<style scoped>
.boolean-switch {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    color: var(--color-text-main);
    font-family: var(--font-family-base), sans-serif;
    font-size: var(--text-body-3-size);
    line-height: var(--text-body-3-line-height);
}

.boolean-switch-input {
    position: absolute;
    width: 1px;
    height: 1px;
    opacity: 0;
}

.boolean-switch-control {
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    width: 32px;
    height: 18px;
    padding: 2px;
    border-radius: 999px;
    background-color: var(--color-border-muted);
    transition: background-color .15s ease;
}

.boolean-switch-thumb {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: var(--color-bg-surface);
    box-shadow: 0 1px 2px rgba(0, 0, 0, .2);
    transition: transform .15s ease;
}

.boolean-switch-input:checked + .boolean-switch-control {
    background-color: var(--color-brand-main);
}

.boolean-switch-input:checked + .boolean-switch-control .boolean-switch-thumb {
    transform: translateX(14px);
}

.boolean-switch-input:focus-visible + .boolean-switch-control {
    outline: 2px solid var(--color-accent-soft);
    outline-offset: 2px;
}

.boolean-switch-disabled {
    cursor: not-allowed;
    opacity: .5;
}
</style>
